/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewpedidolabel3Inputs */

const en_letterpreviewpedidolabel3 = /** @type {(inputs: Letterpreviewpedidolabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The request`)
};

const pt_letterpreviewpedidolabel3 = /** @type {(inputs: Letterpreviewpedidolabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido`)
};

/**
* | output |
* | --- |
* | "The request" |
*
* @param {Letterpreviewpedidolabel3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewpedidolabel3 = /** @type {((inputs?: Letterpreviewpedidolabel3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewpedidolabel3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewpedidolabel3(inputs)
	return pt_letterpreviewpedidolabel3(inputs)
});
export { letterpreviewpedidolabel3 as "letterPreviewPedidoLabel" }